var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowPlay(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15 18.5331C8.9 18.6998 8.64583 18.7081 8.3875 18.5581C8.12917 18.4081 8 18.1831 8 17.8831V6.63314C8 6.33314 8.12917 6.10814 8.3875 5.95814C8.64583 5.80814 8.9 5.81647 9.15 5.98314L18 11.6331C18.2333 11.7831 18.35 11.9915 18.35 12.2581C18.35 12.5248 18.2333 12.7331 18 12.8831L9.15 18.5331Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPlay);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTUgMTguNTMzMUM4LjkgMTguNjk5OCA4LjY0NTgzIDE4LjcwODEgOC4zODc1IDE4LjU1ODFDOC4xMjkxNyAxOC40MDgxIDggMTguMTgzMSA4IDE3Ljg4MzFWNi42MzMxNEM4IDYuMzMzMTQgOC4xMjkxNyA2LjEwODE0IDguMzg3NSA1Ljk1ODE0QzguNjQ1ODMgNS44MDgxNCA4LjkgNS44MTY0NyA5LjE1IDUuOTgzMTRMMTggMTEuNjMzMUMxOC4yMzMzIDExLjc4MzEgMTguMzUgMTEuOTkxNSAxOC4zNSAxMi4yNTgxQzE4LjM1IDEyLjUyNDggMTguMjMzMyAxMi43MzMxIDE4IDEyLjg4MzFMOS4xNSAxOC41MzMxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };